var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesRegiter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.707 15.293 28.414 14l1.293-1.293a1 1 0 0 0 0-1.414l-1.42-1.42 1.545-2.318A1 1 0 0 0 29 6H3a1 1 0 0 0-.832 1.555l1.545 2.318-1.42 1.42a1 1 0 0 0 0 1.414L3.586 14l-1.293 1.293a1 1 0 0 0 0 1.414L3.586 18l-1.293 1.293a1 1 0 0 0 0 1.414l1.42 1.42-1.545 2.318A1 1 0 0 0 3 26h26a1 1 0 0 0 .832-1.555l-1.545-2.318 1.42-1.42a1 1 0 0 0 0-1.414L28.414 18l1.293-1.293a1 1 0 0 0 0-1.414zm-3.414-.586L27.586 16l-1.293 1.293a1 1 0 0 0 0 1.414L27.586 20l-1.293 1.293a1 1 0 0 0-.125 1.262L27.132 24H4.868l.964-1.445a1 1 0 0 0-.125-1.262L4.414 20l1.293-1.293a1 1 0 0 0 0-1.414L4.414 16l1.293-1.293a1 1 0 0 0 0-1.414L4.414 12l1.293-1.293a1 1 0 0 0 .125-1.262L4.868 8h22.264l-.964 1.445a1 1 0 0 0 .125 1.262L27.586 12l-1.293 1.293a1 1 0 0 0 0 1.414zM10.029 14.5a.5.5 0 0 0 .5.5h.942a2.522 2.522 0 0 1 .554 4.977V21a1 1 0 0 1-2 0v-.956h-1a1 1 0 0 1 0-2h2.442a.5.5 0 0 0 .5-.5.512.512 0 0 0-.5-.544h-.942a2.5 2.5 0 0 1-.49-4.95c0-.018-.01-.032-.01-.05v-1a1 1 0 0 1 2 0v1h.942a1 1 0 0 1 0 2h-2.438a.5.5 0 0 0-.5.5zM17 14a1 1 0 1 1 1 1 1 1 0 0 1-1-1zm7 5a1 1 0 1 1-1-1 1 1 0 0 1 1 1zm-.293-5.707a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414l5-5a1 1 0 0 1 1.414 0z",
    "data-name": "Layer 2",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesRegiter);
export default __webpack_public_path__ + "static/media/sales-regiter.c5c8d46f0370b3fd85f3d0813f4352d2.svg";
export { ForwardRef as ReactComponent };